export const SUCCESS_OWNER = 'SUCCESS';
export const ONBOARDING_SPECIALIST = 'ONBOARDING';